<template>
  <div class="s-tool-bar">
    <!-- <div v-if="navData.length" class="s-flex breadcrumb-box">
      <a v-if="back" @click="$router.back()" class="link mr-16">
        <i class="el-icon-back"></i>
        <span class="back">返回</span>
      </a>
      <el-breadcrumb class="s-breadcrumb" separator-class="el-icon-arrow-left">
        <el-breadcrumb-item v-for="(item, index) in navData" :key="index">
          <span v-if="index === navData.length - 1">{{ item }}</span>
          <a v-else @click="$router.go(index-(navData.length - 1))">{{ item }}</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="box">
      <el-breadcrumb
        v-if="navData.length"
        class="s-breadcrumb breadcrumb-bar"
        separator-class="el-icon-arrow-left"
      >
        <el-breadcrumb-item v-for="(item, index) in navData" :key="index">
          <span v-if="index === navData.length - 1">{{ item }}</span>
          <!-- 订单详情页的入口：订单查询/订单号、回款管理/订单、发票管理/订单，发货管理/订单 所以点击订单详情里的订单按钮时要返回到相应的入口页面 -->
          <a
            v-else
            @click="
              index === 0 &&
              conf[item] &&
              !['order', 'billing', 'invoice', 'shipment'].includes(source)
                ? $router.replace(conf[item])
                : $router.go(index - (navData.length - 1))
            "
            >{{ item }}</a
          >
        </el-breadcrumb-item>
      </el-breadcrumb>

      <slot name="tools"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "RtBreadBar",
  props: {
    // back: {
    //   type: Boolean,
    //   default: false
    // },
    navData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      conf: {
        发货: "/shipment/list",
        订单: "/order/list",
        报价: "/quote/list",
        OUT单: "/out_order/out_orderList",
        商机: "/opportunity/list",
        开票: "/invoice/list",
        客户: "/customer/list",
        认款: "/billing/list",
        财务信息: "/financial/list",
        人员档案: "/salesman/list",
        市场物料申请: "/materialLists/list",
        发货地址管理: "/address/list",
        协议: "/agreement/list",
        续签编号: "/agreement/renewlist",
        电子授权函: "/authorization/list",
      },
      source: null,
    };
  },
  mounted: function () {
    if (this.$route.params.source) {
      this.source = this.$route.params.source;
    }
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.s-tool-bar {
  .el-button {
    margin: 10px 0 9px 0 !important;
  }
  .breadcrumb-bar {
    padding: 18px 0;
    .el-breadcrumb__inner > span {
      font-size: 12px !important;
      font-family: PingFang SC;
      font-weight: normal;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      color: #5f7086;
    }
    .el-breadcrumb__inner > a {
      font-size: 12px !important;
      font-family: PingFang SC;
      font-weight: normal;
      letter-spacing: 0px;
      color: #0050b3;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?00b01674